import { InputType } from 'config'
import { ParagraphComponent } from 'utils/RenderParagraph'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    lateCharge: {
      inputType: 'section',
      title: 'Late Charge',
      span: 'full',
      visible: true,
    },
    lateChargeMethod: {
      inputType: 'select',
      options: ['Default', 'Reg AA', 'CC 2954.4'],
      title: 'Late Charge Method',
      hasDefaultOption: true,
      visible: true,
    },
    graceDays: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Number of Grace Days',
      visible: true,
    },
    graceDaysMethod: {
      inputType: 'select',
      options: ['Business Days', 'Calendar Days'],
      title: 'Grace Days Method',
      hasDefaultOption: true,
      visible: true,
    },
    minimumLateCharge: {
      title: 'Minimum Late Charge',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '$',
      visible: true,
    },
    percentageOption: {
      inputType: 'select',
      options: ['Total Pmt', 'P & I'],
      title: 'Percentage Option',
      hasDefaultOption: true,
      visible: false,
    },
    percentage: {
      title: 'Percentage',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      visible: true,
    },
    additionalDailyAmount: {
      title: 'Additional Daily Amount',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '$',
      visible: true,
    },
    distributeToLendersLateCharge: {
      title: 'Distribute to Lenders',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      visible: true,
    },
    distributeToOrigVendorLateCharge: {
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      title: 'Distribute to Orig. Vendor',
      visible: true,
    },
    distributeToCompanyLateCharge: {
      title: 'Distribute to Company',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      visible: true,
    },
    defaultInterestTitle: {
      inputType: 'section',
      title: 'Default Interest',
      span: 'full',
      visible: true,
    },
    defaultInterest: {
      inputType: 'ToggleButton',
      title: 'Default Interest',
      span: 'full',
      textLeft: true,
      visible: true,
    },
    defaultAfter: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Default After',
      visible: true,
    },
    defaultAfterUnit: {
      inputType: 'select',
      options: ['Days', 'Weeks', 'Months'],
      title: 'Default After Unit',
      hasDefaultOption: true,
      visible: false,
    },
    defaultEffectiveUntil: {
      inputType: 'select',
      options: ['Current', 'Indefinite'],
      title: 'Default Effective Until',
      hasDefaultOption: true,
      visible: true,
    },
    defaultRateMethod: {
      inputType: 'select',
      options: ['Fixed Rate', 'Adjustable Rate'],
      title: 'Default Rate Method',
      hasDefaultOption: true,
      visible: true,
    },
    defaultRateValue: {
      inputType: 'text',
      type: 'number',
      title: 'Default Rate Value',
      visible: true,
    },
    distributeToLendersDefaultInterest: {
      title: 'Distribute to Lenders',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      visible: true,
    },
    distributeToOrigVendorDefaultInterest: {
      title: 'Distribute to Orig. Vendor',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      visible: true,
    },
    distributeToCompanyDefaultInterest: {
      title: 'Distribute to Company',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      visible: true,
    },
    defaultRateHistory: {
      title: 'Default Rate History',
      inputType: 'text',
      type: 'number',
      visible: true,
    },
    prepaymentPenalty: {
      inputType: 'section',
      title: 'Prepayment Penalty',
      span: 'full',
      visible: true,
    },
    noPrepaymentPenalty: {
      inputType: 'checkbox',
      title: '1. No Prepayment Penalty',
      span: 'full',
      visible: true,
    },
    anyPrepaymentPenalty: {
      inputType: 'checkbox',
      title: '2. Any Prepayments of principal',
      visible: true,
    },
    anyPrepaymentPenaltyOption1: {
      inputType: 'text',
      type: 'text',
      title: '',
      visible: false,
    },
    anyPrepaymentPenaltyOption2: {
      inputType: 'Select',
      title: '',
      hasDefaultOption: true,
      options: ['Unpaid Balance', 'Original Balance'],
      visible: false,
    },
    anyPrepaymentPenaltyOption3: {
      inputType: 'text',
      type: 'text',
      title: '',
      visible: false,
    },
    anyPrepaymentPenaltyOption4: {
      inputType: 'Select',
      title: '',
      hasDefaultOption: true,
      options: ['Unpaid Balance', 'Original Balance'],
      visible: false,
    },
    otherPrepaymentPenalty: {
      inputType: 'checkbox',
      title: '3. Other',
      visible: true,
    },
    otherPrepaymentPenaltyOption: {
      inputType: 'Select',
      title: 'Option',
      hasDefaultOption: true,
      options: [
        'None',
        '5 4 3 2 1 Prepay',
        'Declining Term Prepay',
        'Landmarc Prepay (6 months)',
        'Guaranteed Interest Through Expiration Date',
        '2% of Unpaid Principal Balance',
        '5% of Unpaid Principal Balance',
        '3% of Original Amount',
        '2% of Original Amount',
        '1% of Original Amount',
        '3 2 1 (Years) Percent of Original Amount',
        '3 2 1 (Months) Percent of Original Amount',
      ],
      className: 'md:col-start-2',
      span: 'full',
      visible: true,
    },
    prepaymentPenaltyExpirationAndDistribution: {
      inputType: 'section',
      title: 'Prepayment Penalty Expiration & Distribution',
      span: 'full',
      visible: true,
    },
    prepaymentPenaltyExpires: {
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      title: 'Prepayment Penalty Expires',
      visible: true,
    },
    distributeToLendersPrepayment: {
      title: 'Distribute to Lenders',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      visible: true,
    },
    distributeToOrigVendorPrepayment: {
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      title: 'Distribute to Orig. Vendor',
      visible: true,
    },
    distributeToCompanyPrepayment: {
      title: 'Distribute to Company',
      inputType: 'text',
      type: 'thousandSep',
      prefix: '%',
      visible: true,
    },
  }
}

export const paragraphs = (inputs: Record<string, InputType>): ParagraphComponent[][] => {
  return [
    [
      {
        input: { inputType: 'span', title: 'Any payments of principal in any calendar year in excess of ' },
        needSplit: true,
      },
      {
        input: inputs.anyPrepaymentPenaltyOption1,
        Key: 'anyPrepaymentPenaltyOption1',
      },
      {
        input: { inputType: 'span', title: 'of the ' },
        needSplit: true,
      },
      {
        input: inputs.anyPrepaymentPenaltyOption2,
        Key: 'anyPrepaymentPenaltyOption2',
      },
      {
        input: { inputType: 'span', title: 'will include a penalty not to exceed ' },
        needSplit: true,
      },
      {
        input: inputs.anyPrepaymentPenaltyOption3,
        Key: 'anyPrepaymentPenaltyOption3',
      },
      {
        input: { inputType: 'span', title: 'months advance interest on the ' },
        needSplit: true,
      },
      {
        input: inputs.anyPrepaymentPenaltyOption4,
        Key: 'anyPrepaymentPenaltyOption4',
      },
      {
        input: {
          inputType: 'span',
          title:
            'at the note rate, but not more than the interest that would be charged if the loan were paid to maturity.',
        },
      },
    ],
  ]
}
